{
  "LOGIN": {
    "TITLE": "Увійти до Chatwoot",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Будь ласка, введіть коректну адресу електронної пошти"
    },
    "PASSWORD": {
      "LABEL": "Пароль",
      "PLACEHOLDER": "Пароль"
    },
    "API": {
      "SUCCESS_MESSAGE": "Вхід успішний",
      "ERROR_MESSAGE": "Не вдалося підключитися до Woot сервера. Будь ласка, спробуйте ще раз.",
      "UNAUTH": "Неправильне ім'я користувача / пароль. Будь ласка, спробуйте ще раз."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Увійти через Google",
      "BUSINESS_ACCOUNTS_ONLY": "Будь ласка, використовуйте робочу адресу електронної пошти для входу",
      "NO_ACCOUNT_FOUND": "Ми не змогли знайти аккаунт для вашої адреси електронної пошти."
    },
    "FORGOT_PASSWORD": "Забули пароль?",
    "CREATE_NEW_ACCOUNT": "Створити новий обліковий запис",
    "SUBMIT": "Увійти",
    "SAML": {
      "LABEL": "Login via SSO",
      "TITLE": "Initiate Single Sign-on (SSO)",
      "SUBTITLE": "Enter your work email to access your organization",
      "BACK_TO_LOGIN": "Login via Password",
      "WORK_EMAIL": {
        "LABEL": "Work Email",
        "PLACEHOLDER": "Enter your work email"
      },
      "SUBMIT": "Continue with SSO",
      "API": {
        "ERROR_MESSAGE": "SSO authentication failed. Please check your credentials and try again."
      }
    }
  }
}
